/**
 * This is the registration controller.
 * @memberOf registration Module
 * @namespace registration Controller
 */

/**
 * @name registrationController
 * @desc Create the controller.
 * @param $scope
 * @param coreService
 * @memberOf registration Module.registration Controller
 * @ngInject
 */
function registrationController($scope, $translate, coreService, $window, $log) {
  // Assign this controller as the view-model.
  var vm = this;
  // Register the view model's properties.
  vm.validateForm = validateForm;
  vm.submitted = false;
  vm.email = "";
  vm.confirmemail = "";
  vm.messages = [];
  vm.hideReminder = true;
  vm.setNotification = setNotification;
  vm.sendEmail = "0";
  vm.hasReturnLink = false;
  // Activate the controller.
  
  //handle email focus validation
  vm.showEmailValidation = false;
  vm.showConfirmEmailValidation = false;
  vm.cancelRegistration= cancelRegistration;  

  $window.onload = function() {
    // Have to manually set the title rather than from app.run.js as titles from app.run are set on stateChange
    // User Registration page can't be accessed using stateChange. It is directly loaded for a new user
    $translate(['application.title', 'application.selfservice.registeruser'])
      .then(function(data) {
          $window.document.title = data['application.title'] + ' | ' + data['application.selfservice.registeruser'];          
    });
   };
  
  activate();

  // Activates the controller.
  function activate() {    
    // Read Identity Server's data model
    var model = coreService.getIdentityModel();
    // Display error returned by Identity Server
    if (model.errorMessage) {
      //$log.error(model.errorMessage);
      vm.messages.push(model.errorMessage);
    }

    // Change display language
    if (model.custom && model.custom.ui_locales) {
      $translate.use(model.custom.ui_locales);
    }

    vm.hasReturnLink = (model.return_url || '') != '';
    $scope.model = model;
  }

  function setNotification() {
	vm.email = "";
    vm.confirmemail = "";
  }
 
   //return true if submit button needs to be disabled
   $scope.disableSubmit=function(e){               
               return ($scope.registrationForm.firstName.$invalid || $scope.registrationForm.lastName.$invalid || 
			   (vm.sendEmail == '1' && ($scope.registrationForm.confirmemail.$invalid || $scope.registrationForm.email.$invalid || !$scope.registrationForm.email.$modelValue || ($scope.registrationForm.email.$modelValue !== $scope.registrationForm.confirmemail.$modelValue))));
   };
  
  // Validate the registration form.
  function validateForm(e) {	
	// Update the form.
	vm.messages = [];
	vm.submitted = true;
	$scope.registrationForm.$dirty = true;
	$scope.registrationForm.$pristine = false;	
	
    if ($scope.registrationForm.$invalid) {
      // Do not submit
      e.preventDefault();
    }
  }

  function cancelRegistration(){
    window.location.replace($scope.model.return_url);
  }
}

export default registrationController;



// WEBPACK FOOTER //
// ./src/login/registration/registration.controller.js